import React from "react";
import { IconButton } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import Modal from "repoV2/components/common/Modal/Modal";
import ExlyInput from "repoV2/features/Common/modules/Form/modules/ExlyInput/ExlyInput";
import checkoutCommonStyles from "repoV2/features/CheckoutPages/CheckoutCommonStyles.module.scss";
import InputAdornment from "@mui/material/InputAdornment";
import { Button } from "repoV2/components/common/Button";
import { classNames } from "repoV2/utils/common/render/classNames";
import {
    COUPON_TYPES,
    loyalty_email,
} from "../../CouponCodeFormGroup.constants";
import Coupon from "../Coupon/Coupon";
import { useLoyaltyCoupons } from "./LoyaltyCoupons.utils";
import styles from "./LoyaltyCoupons.module.scss";

const LoyaltyCoupons = ({
    open,
    onModalClose,
    setIsModalOpen,
    onApplyCouponCodeClick,
}: {
    open: boolean;
    onModalClose: () => void;
    setIsModalOpen: (open: boolean) => void;
    onApplyCouponCodeClick: ({
        couponType,
        code,
    }: {
        couponType?: number | undefined;
        code?: string | undefined;
    }) => void;
}) => {
    const {
        emailValidator,
        onLoyaltyCheckClick,
        handleModalClose,
        appliedCouponCodeData,
        currency,
        isCheckButtonClicked,
        loyaltyList,
        onApplyLoyaltyCodeClick,
    } = useLoyaltyCoupons({
        onModalClose,
        onApplyCouponCodeClick,
        setIsModalOpen,
    });

    if (!open) {
        return null;
    }

    const inputAdornmentJSX = (
        <InputAdornment position="end">
            <Button
                className={classNames(styles.buttonBase, styles.applyButton)}
                type="button"
                design="plain"
                onClick={onLoyaltyCheckClick}
            >
                CHECK
            </Button>
        </InputAdornment>
    );

    const renderContent = (
        <div>
            <div className={styles.footer}>
                <div className={styles.couponText}>
                    Enter your Email to check your coupons
                </div>
                <ExlyInput
                    name={loyalty_email}
                    type="email"
                    classes={{
                        helperText: checkoutCommonStyles.helperText,
                    }}
                    registerOptions={{
                        validate: emailValidator,
                    }}
                    overrideInputProps={{
                        placeholder: "Email",
                        fullWidth: true,
                        InputProps: {
                            className: checkoutCommonStyles.inputBaseText,
                            endAdornment: inputAdornmentJSX,
                        },
                        className: checkoutCommonStyles.inputCustomStyles,
                    }}
                />
            </div>
        </div>
    );

    return (
        <>
            <Modal
                open={open}
                classes={{
                    root: styles.RootModalClass,
                    paper: styles.RootStyles,
                }}
                onClose={handleModalClose}
            >
                <div className={styles.mainModalContainer}>
                    <div className={styles.modalHeaderStyle}>
                        <div>Loyalty Coupons</div>
                        <IconButton
                            onClick={handleModalClose}
                            className={styles.iconButtonStyle}
                        >
                            <CloseRoundedIcon
                                className={styles.closeIconStyle}
                            />
                        </IconButton>
                    </div>
                    <div className={styles.modalBodyStyle}>
                        <div className={styles.modlInnerBodyStyle}>
                            {renderContent}
                            {loyaltyList.length > 0 && (
                                <div className={styles.availableCouponsText}>
                                    Available Coupons
                                </div>
                            )}
                            <div className={styles.couponListContainer}>
                                <div className={styles.couponsList}>
                                    {loyaltyList.length > 0
                                        ? loyaltyList.map(list => {
                                              const {
                                                  code,
                                                  value,
                                                  expiry,
                                                  type,
                                              } = list;
                                              return (
                                                  <>
                                                      <Coupon
                                                          key={code}
                                                          code={code}
                                                          value={value}
                                                          expiry={expiry}
                                                          type={type}
                                                          currency={currency}
                                                          couponType={
                                                              COUPON_TYPES.LOYALTY_COUPON
                                                          }
                                                          appliedCouponCodeValue={
                                                              appliedCouponCodeData.couponCode ||
                                                              ""
                                                          }
                                                          onApplyCouponCodeClick={
                                                              onApplyLoyaltyCodeClick
                                                          }
                                                      />
                                                  </>
                                              );
                                          })
                                        : isCheckButtonClicked && (
                                              <div className={styles.emptylist}>
                                                  <div>
                                                      <img
                                                          src="/static/images/checkout_pages/empty_list.svg"
                                                          alt="empty-list"
                                                      />
                                                  </div>
                                                  <div
                                                      className={
                                                          styles.emptyText
                                                      }
                                                  >
                                                      Sorry, No coupons
                                                      available
                                                  </div>
                                              </div>
                                          )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default LoyaltyCoupons;
